<template>
  <v-container fill-height>
    <v-row class="align-center justify-center">
      <v-col cols="12" class="col-sm-5 col-md-6 col-lg-4 col-xl-3">
        <v-card elevation-12  v-show="(!$store.getters.isLogin) ? true : false" class="rounded-xl">
          <v-toolbar
            color="primary"
            dark
            class="rounded-xl"
            height="130"
          >
              <div class="mx-auto">
                <v-img :src="require('@/assets/logo.png')" width="300" />
                <!-- <p>
                  A Revolução Da <span :style="styleText"> Sua Segurança</span> Chegou
                </p> -->
              </div>
            <!-- <v-toolbar-title>
            </v-toolbar-title> -->
          </v-toolbar>
          <v-window v-model="step">
            <v-window-item :value="1" :class="classWindow">
                <Login @action="action" :emailLogin="emailLogin" @initCountDown="resetCount" />
            </v-window-item>
            <v-window-item :value="2" :class="classWindow">
                <Cadastro @action="action"/>
            </v-window-item>
            <v-window-item :value="3" :class="classWindow">
                <RecuperacaoSenha @action="action" :initCount="getCountDown" />
            </v-window-item>
            <v-window-item :value="4" :class="classWindow">
                <NovaSenha @action="action" />
            </v-window-item>
            <v-window-item :value="5" :class="classWindow">
                <LoginHost @action="action" :emailLogin="emailLogin" :listHost="listHost" />
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import Login from "./Login"
import Cadastro from "./Cadastro"
import RecuperacaoSenha from "./RecuperacaoSenha"
import NovaSenha from "./NovaSenha"
import LoginHost from "./LoginHost"

export default {
  name: 'ViewLogin',
  components:{
      Login,
      Cadastro,
      RecuperacaoSenha,
      NovaSenha,
      LoginHost,
  },
  data(){
    return{
      classWindow:"px-2 py-2",
      step: 5,
      countDown:'123',
      emailLogin:'',
      listHost:[],
    }
  },
  methods:{
    action($event){
      this.step = $event.page;
      if ( Object.prototype.hasOwnProperty.call($event,'content')) {
        this.emailLogin = $event.content.email
      if ( Object.prototype.hasOwnProperty.call($event.content,'listHost')) {
        this.listHost = [ ...$event.content.listHost]
      }
      }
    },
    resetCount(){
      this.countDown = Date.now()
    }
  },
  computed: {
    styleText(){
      return {
        color:"var(--v-cor_detalhe-base)"
      }
    },
    getCountDown(){
      return this.countDown
    },
    titlePage () {
      switch (this.step) {
        case 1: return 'Login'
        case 2: return 'Cadastre-se'
        case 3: return 'Recuperação senha'
        case 4: return 'Nova Senha'
        case 5: return 'Selecione o local'
        default: return ''
      }
    },
  },
}
</script>